import React from "react";

import { Props } from "./types";

function ToggleArrow({ className }: Props) {
  return (
    <svg
      className={className}
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34 21"
    >
      <path
        d="M15.446,1.92a2,2,0,0,1,3.109,0L31.362,17.742A2,2,0,0,1,29.808,21H4.192a2,2,0,0,1-1.554-3.258Z"
        transform="translate(34 21) rotate(180)"
      />
    </svg>
  );
}

export { ToggleArrow };
